import "./accueil.js"
import "./single.js"
import "./projects.js"
import "./agence.js"